import { es } from "dayjs/locale/es";
import { useState } from "react";
import { PDFDocument, rgb, StandardFonts } from "pdf-lib";
import { planPagos } from "../../utils/planPagos";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { formatNumber } from "../../utils/format";
import { capitalize } from "./capitalize";
import { formatCurrency } from "../../utils/formatCurrency";
import { formatCurrencyTable } from "../../utils/formatCurrencyTable";
dayjs.extend(relativeTime);
dayjs.extend(customParseFormat);
dayjs.locale("es");

function WithoutCodeudor({ data, status, company }) {
  const [loading, setLoading] = useState(false);

  const { schedule, totalCredit, totalInterest } = planPagos(data);

  const generarCertificado = async () => {
    setLoading(true);

    // Cargar el PDF de plantilla
    const pdfUrl = "/documentos_sin_codeudor.pdf";
    const existingPdfBytes = await fetch(pdfUrl).then((res) =>
      res.arrayBuffer()
    );

    // Cargar el PDF en pdf-lib
    const pdfDoc = await PDFDocument.load(existingPdfBytes);

    const font = await pdfDoc.embedFont(StandardFonts.HelveticaBold);

    // Obtener la primera página y agregar texto
    const page = pdfDoc.getPage(0);

    /////////////credito

    page.drawText(`${company.name_company}`, {
      x: 33,
      y: 685,
      size: 9,
      font: font,
    });

    page.drawText(`${data.numberCredit}`, {
      x: 70,
      y: 612,
      size: 9,
      color: rgb(1, 0, 0),
    });

    page.drawText(`${formatNumber(data.ammount)}`, {
      x: 270,
      y: 612,
      size: 9,
      color: rgb(0, 0, 0),
    });

    page.drawText("Libre Inversión", {
      x: 420,
      y: 612,
      size: 9,
      color: rgb(0, 0, 0),
    });

    page.drawText(`${formatNumber(schedule[0]?.cuotaAPagar.toFixed(0))}`, {
      x: 70,
      y: 562,
      size: 9,
      color: rgb(0, 0, 0),
    });

    page.drawText(`${schedule?.length}`, {
      x: 250,
      y: 562,
      size: 9,
      color: rgb(0, 0, 0),
    });

    page.drawText(`${data.tasa} %`, {
      x: 350,
      y: 562,
      size: 9,
      color: rgb(0, 0, 0),
    });

    page.drawText(`${formatNumber(totalCredit.toFixed(0))}`, {
      x: 450,
      y: 562,
      size: 9,
      color: rgb(0, 0, 0),
    });

    ////primer descuentop

    page.drawText(`${schedule[0]?.fechaPago.split("/")[2]}`, {
      x: 53,
      y: 515,
      size: 9,
      color: rgb(0, 0, 0),
    });

    const nuevaFechaMesAnterior = dayjs(schedule[0]?.fechaPago, "DD/MM/YYYY")
      .subtract(1, "month")
      .format("MM");

    page.drawText(`${nuevaFechaMesAnterior}`, {
      x: 133,
      y: 515,
      size: 9,
      color: rgb(0, 0, 0),
    });

    page.drawText(
      `${schedule[0]?.fechaPago.split("/")[1] === "02" ? "28" : "30"}`,
      {
        x: 203,
        y: 515,
        size: 9,
        color: rgb(0, 0, 0),
      }
    );

    page.drawText(`${schedule[0]?.fechaPago.split("/")[2]}`, {
      x: 253,
      y: 515,
      size: 9,
      color: rgb(0, 0, 0),
    });

    const fecha = schedule[0]?.fechaPago; // "20/07/2025"

    const nuevaFecha = dayjs(fecha, "DD/MM/YYYY").format("MM");

    page.drawText(`${nuevaFecha}`, {
      x: 300,
      y: 515,
      size: 9,
      color: rgb(0, 0, 0),
    });

    page.drawText(`10`, {
      x: 350,
      y: 515,
      size: 9,
      color: rgb(0, 0, 0),
    });

    ///Vencimiento final

    page.drawText(`${schedule[schedule.length - 1]?.fechaPago.split("/")[2]}`, {
      x: 400,
      y: 515,
      size: 9,
      color: rgb(0, 0, 0),
    });

    page.drawText(`${schedule[schedule.length - 1]?.fechaPago.split("/")[1]}`, {
      x: 470,
      y: 515,
      size: 9,
      color: rgb(0, 0, 0),
    });

    page.drawText(`${schedule[schedule.length - 1]?.fechaPago.split("/")[0]}`, {
      x: 540,
      y: 515,
      size: 9,
      color: rgb(0, 0, 0),
    });

    /////

    ///nombres deudores
    page.drawText(`${data.name} ${data.lastName}`, {
      x: 70,
      y: 192,
      size: 9,
      color: rgb(0, 0, 0),
    });

    page.drawText(`${formatCurrency(data.identity)}`, {
      x: 96,
      y: 180,
      size: 9,
      color: rgb(0, 0, 0),
    });
    ///codeudor
    page.drawText("", {
      x: 330,
      y: 192,
      size: 9,
      color: rgb(0, 0, 0),
    });

    page.drawText("", {
      x: 352,
      y: 180,
      size: 9,
      color: rgb(0, 0, 0),
    });

    page.drawText(`${company.name} ${company.lastName}`, {
      x: 70,
      y: 85,
      size: 9,
      font: font,
    });

    //////

    // Obtener la segunda página y agregar texto
    const page2 = pdfDoc.getPage(1);

    /////////////credito

    page2.drawText(`${data.name} ${data.lastName}`, {
      x: 100,
      y: 629,
      size: 9,
      color: rgb(0, 0, 0),
    });

    page2.drawText(`${formatCurrency(data.identity)}`, {
      x: 150,
      y: 616,
      size: 9,
      color: rgb(0, 0, 0),
    });

    page2.drawText(`${data.expedition}`, {
      x: 300,
      y: 616,
      size: 9,
      color: rgb(0, 0, 0),
    });

    page2.drawText(`${dayjs(data.start_date).format("DD")}`, {
      x: 300,
      y: 318,
      size: 9,
      color: rgb(0, 0, 0),
    });

    page2.drawText(`${capitalize(dayjs(data.start_date).format("MMMM"))}`, {
      x: 440,
      y: 318,
      size: 9,
      color: rgb(0, 0, 0),
    });

    page2.drawText(`${capitalize(dayjs(data.start_date).format("YYYY"))}`, {
      x: 100,
      y: 305,
      size: 9,
      color: rgb(0, 0, 0),
    });

    //Deudor

    page2.drawText(`${data.name} ${data.lastName}`, {
      x: 130,
      y: 234,
      size: 9,
      color: rgb(0, 0, 0),
    });

    page2.drawText(`${formatCurrency(data.identity)}`, {
      x: 155,
      y: 222,
      size: 9,
      color: rgb(0, 0, 0),
    });

    ///

    // Obtener la tercera página y agregar texto
    const page3 = pdfDoc.getPage(2);

    page3.drawText(`${data.numberCredit}`, {
      x: 420,
      y: 672,
      size: 10,
      color: rgb(1, 0, 0),
    });

    page3.drawText(`${data.name} ${data.lastName}`, {
      x: 75,
      y: 172,
      size: 9,
      color: rgb(0, 0, 0),
    });

    page3.drawText(`${formatCurrency(data.identity)}`, {
      x: 105,
      y: 162,
      size: 9,
      color: rgb(0, 0, 0),
    });

    const logoUrl = "/logo_lendy.png"; // Ruta al logo
    const logoBytes = await fetch(logoUrl).then((res) => res.arrayBuffer());
    const logoImage = await pdfDoc.embedPng(logoBytes);
    const logoDims = logoImage.scale(0.07); // Escala el logo

    // Obtener la cuarta página y agregar tabla
    const pageWidth = 595.28;
    const pageHeight = 841.89;
    const margin = 50;
    const rowHeight = 20;
    const columnWidths = [50, 90, 80, 90, 70, 70, 70]; // Anchos de columnas
    const headers = [
      "Cuotas",
      "Fecha de descuento",
      "Valor préstamo",
      "Cuota a pagar",
      "Capital",
      "Interés",
      "Saldo deuda",
    ];
    const headerBackgroundColor = rgb(3 / 255, 32 / 255, 99 / 255);
    const maxRowsPerPage = 30; // Cambia esto si quieres más o menos filas por hoja

    // Función para crear una nueva página con logo y encabezado
    const createNewPageWithHeader = () => {
      const page = pdfDoc.addPage([pageWidth, pageHeight]);

      // Logo
      page.drawImage(logoImage, {
        x: page.getWidth() - logoDims.width - 20,
        y: page.getHeight() - logoDims.height - 20,
        width: logoDims.width,
        height: logoDims.height,
      });

      // Encabezados
      headers.forEach((header, i) => {
        const x = margin + columnWidths.slice(0, i).reduce((a, b) => a + b, 0);
        const y = pageHeight - margin - rowHeight - 20;

        page.drawRectangle({
          x,
          y,
          width: columnWidths[i],
          height: rowHeight,
          color: headerBackgroundColor,
        });

        page.drawText(header, {
          x: x + 5,
          y: y + 5,
          size: 9,
          color: rgb(1, 1, 1),
        });
      });

      return page;
    };

    // Crear la primera página de tabla
    let currentPage = createNewPageWithHeader();
    let currentY = pageHeight - margin - 2 * rowHeight;

    // Dibujar filas
    schedule.forEach((row, rowIndex) => {
      // Si llegamos al límite, crear nueva página
      if (rowIndex > 0 && rowIndex % maxRowsPerPage === 0) {
        currentPage = createNewPageWithHeader();
        currentY = pageHeight - margin - 2 * rowHeight;
      }

      headers.forEach((_, colIndex) => {
        const x =
          margin + columnWidths.slice(0, colIndex).reduce((a, b) => a + b, 0);
        const y = currentY - rowHeight;

        // Dibujar bordes
        currentPage.drawRectangle({
          x,
          y,
          width: columnWidths[colIndex],
          height: rowHeight,
          borderColor: rgb(0, 0, 0),
          borderWidth: 1,
        });

        // Texto de celda
        const text = [
          row.cuota.toString(),
          row.fechaPago.toString(),
          formatCurrencyTable(row.valorPrestamo),
          formatCurrency(row.cuotaAPagar),
          formatCurrency(row.capital),
          formatCurrency(row.interes),
          formatCurrency(row.saldoDeuda),
        ][colIndex];

        currentPage.drawText(text, {
          x: x + 5,
          y: y + 5,
          size: 10,
          color: rgb(0, 0, 0),
        });
      });

      currentY -= rowHeight;
    });

    // Obtener la última página

    const lastPageIndex = pdfDoc.getPageCount() - 1;
    const lastPage = pdfDoc.getPage(lastPageIndex);

    const page4 = pdfDoc.getPage(3);

    page4.drawText("Crédito", {
      x: 45,
      y: 782,
      size: 18,
      color: rgb(0, 0, 0),
    });

    lastPage.drawText("En prueba de aceptación", {
      x: 55,
      y: 102,
      size: 10,
      color: rgb(0, 0, 0),
    });
    lastPage.drawText("____________________", {
      x: 55,
      y: 82,
      size: 10,
      color: rgb(0, 0, 0),
    });
    lastPage.drawText("Firma", {
      x: 55,
      y: 68,
      size: 10,
      color: rgb(0, 0, 0),
    });
    lastPage.drawText("Nombre:", {
      x: 55,
      y: 48,
      size: 10,
      color: rgb(0, 0, 0),
    });
    lastPage.drawText("Cédula:", {
      x: 55,
      y: 38,
      size: 10,
      color: rgb(0, 0, 0),
    });

    // Guardar el PDF modificado como bytes
    const pdfBytes = await pdfDoc.save();

    // Crear un Blob con los bytes del PDF modificado
    const blob = new Blob([pdfBytes], { type: "application/pdf" });

    // Crear una URL para el Blob
    const url = URL.createObjectURL(blob);

    // Abrir una nueva pestaña con el PDF generado
    const newWindow = window.open(url, "_blank");

    setTimeout(() => {
      newWindow.document.title = "Solicitud sin codeudor - Jhon García";
    }, 100); // Ajusta el tiempo según sea necesario

    setLoading(false);
  };

  return (
    <div>
      <p className="text-xs text-gray-700">
        {status !== "aprobado"
          ? "No puedes descargar esta solicitud si el estado no es aprobado"
          : false}
      </p>
      <button
        onClick={() => generarCertificado()}
        className={`!mx-0  rounded-lg py-1 px-2 text-white font-semibold mt-3 ${
          status !== "aprobado" ? "bg-richBlack/50" : "bg-richBlack"
        }`}
        aria-disabled={status !== "aprobado" ? true : false}
        disabled={status !== "aprobado" ? true : false}
      >
        Descargar Solicitud Sin Codeudor
      </button>
    </div>
  );
}

export default WithoutCodeudor;
